/**
 * A dataset card's state, from the API's answer (ASB-4377). The Console's
 * rule: a 404 means "not available" (the panel or dataset does not exist for
 * this caller), a 403 means the caller may not see it, and anything else is a
 * failure — never dressed up as "no data", or an outage reads as a quiet day.
 */
export const CARD_STATUSES = [
	"loading",
	"ready",
	"empty",
	"missing",
	"forbidden",
	"failed",
	"unsupported",
];

export function statusFromError(error) {
	const status = error?.status;
	if (status === 404) return "missing";
	if (status === 403) return "forbidden";
	return "failed";
}

// apiClient's own transport string when the server sent no message. Never
// shown to an admin; the card says the server did not say why.
const TRANSPORT = /^(API request failed|Network request failed)/;

/** The server's own words for a failure, or null when it gave none. */
export function serverMessage(error) {
	const message = error?.message;
	if (!message || TRANSPORT.test(message)) return null;
	return message;
}

/** Headline and detail copy for a non-ready state. */
export function statusCopy(status, { title, error, message } = {}) {
	switch (status) {
		case "missing":
			return { headline: message ?? "This data is not available.", detail: null };
		case "forbidden":
			return { headline: message ?? "Not available for your account.", detail: null };
		case "failed":
			return {
				headline: `${title ?? "This data"} could not be loaded.`,
				detail: serverMessage(error) ?? "The server did not say why.",
			};
		case "empty":
			return { headline: message ?? "No data for this range.", detail: null };
		case "unsupported":
			return { headline: message ?? "This chart type is not supported yet.", detail: null };
		default:
			return { headline: "", detail: null };
	}
}
